var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2461 0C11.5722 0 12.8439 0.526784 13.7816 1.46447C14.7193 2.40215 15.2461 3.67392 15.2461 5C15.2461 6.32608 14.7193 7.59785 13.7816 8.53553C12.8439 9.47322 11.5722 10 10.2461 10C8.92001 10 7.64824 9.47322 6.71056 8.53553C5.77288 7.59785 5.24609 6.32608 5.24609 5C5.24609 3.67392 5.77288 2.40215 6.71056 1.46447C7.64824 0.526784 8.92001 0 10.2461 0ZM10.2461 12.5C15.7711 12.5 20.2461 14.7375 20.2461 17.5V20H0.246094V17.5C0.246094 14.7375 4.72109 12.5 10.2461 12.5Z",
    fill: "#5D5D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.32e849e7523aebef921bef0cf2db6888.svg";
export { ForwardRef as ReactComponent };